import type { Transition } from 'framer-motion';

export type WebinarAnimations =
  | 'chat.open'
  | 'chat.close'
  | 'chat.gone'
  | 'chat.bubbles.hide.all'
  | 'chat.bubbles.show.all'
  | 'chat.disable.input.focus'
  | 'chat.disable.input.blur'
  | 'actions.open'
  | 'actions.close'
  | 'actions.gone'
  | 'actions.overlay.open'
  | 'actions.overlay.close'
  | 'card.new'
  | 'card.show'
  | 'card.exit'
  | 'card.expand.all';

export type Transitions = Record<
  string,
  Omit<Transition, 'just'> & {
    duration?: number;
    stiffness?: number;
    damping?: number;
    mass?: number;
  }
>;

export const defaultTransitions: Transitions = {
  'agenda.tray': { duration: 0.25 },
  'card.new': { duration: 1.25 },
  'card.show': { duration: 1.25, type: 'tween' },
  'card.expand': { duration: 1, type: 'spring' },
  'cards.scroll': { duration: 0.75, type: 'spring' },
  //'cards.snap': { duration: 0.25, type: 'spring', stiffness: 200, damping: 200 },
  'icon.badge.exit': { duration: 0.4 },
  'score.change': { duration: 1, type: 'spring' },
  'video.resize': { duration: 1.25, type: 'tween' },
  'actions.open': { duration: 1.25, type: 'tween', delay: 1 }, // Same as video.resize + delay
  'video.curtain': { type: 'tween', duration: 3 },
  'chat.notification': { duration: 8 },
  'chat.bubbles.show.all': { duration: 0.5, type: 'tween' },
  'chat.bubbles.show.all.opaque': { duration: 0.5, delay: 0.25 },
  'card.notification.hide': { delay: 5 }, // How long to see card notifications
  'chat.drawer.open': { duration: 0.4, stiffness: 150, damping: 20, mass: 1, type: 'spring' },
  'chat.drawer.close': { duration: 1 },
  'icon.exit': { delay: 2, duration: 1, type: 'tween' },
  'icon.afterExit': { delay: 2.5, duration: 0.5, type: 'tween' },
  'card.exit': { delay: 2, duration: 1, type: 'tween' },
  'card.focus': { duration: 0.75, type: 'tween' },
  'actions.overlay': { delay: 0, duration: 0, type: 'tween' },
  'card.poll.results': { duration: 1, stiffness: 350, damping: 20, mass: 1, type: 'spring' },
};
